export default __webpack_public_path__ + "static/media/Arte_Árbol_Amarillo.b181dd28.png";